export enum AgentSelectionType {
  OBJECT_TYPES = 'object',
  METADATA_TYPES = 'metadata',
}
